
import { supabaseCustomRole } from '@/lib/supabase/customRoleClient';
import { createLatestPricesMap } from '../dealerTransformers';

export const fetchDealersData = async () => {
  console.log("Fetching dealers using vw_dealers_with_ratings view...");
  
  const { data: dealersData, error: dealersError } = await supabaseCustomRole
    .from('vw_dealers_with_ratings')
    .select('*');
    
  if (dealersError) {
    console.error("Error fetching dealers:", dealersError);
    throw dealersError;
  }
  
  return dealersData;
};

export const fetchQuotationsData = async () => {
  const { data: quotations, error: quotationsError } = await supabaseCustomRole
    .from('dealer_quotations')
    .select('dealer_id, metal, spread_percentage, spread_fixed, spread_type')
    .eq('metal', 'ORO')
    .order('created_at', { ascending: false });
  
  if (quotationsError) {
    console.error("Error fetching quotations:", quotationsError);
    throw quotationsError;
  }
  
  return quotations;
};

export const fetchDealersWithPrices = async () => {
  const dealersData = await fetchDealersData();
  const quotations = await fetchQuotationsData();
  return { dealersData, latestPrices: createLatestPricesMap(quotations, dealersData) };
};
